import React, { Component } from 'react';
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import { withRouter } from 'react-router-dom';
import MaterialTable from "material-table";
import { forwardRef } from 'react';
import classNames from 'classnames';
import compose from 'recompose/compose';
import { withTranslation } from 'react-i18next';
// Material helpers
import { withStyles } from '@material-ui/core/styles';

import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

import { api_host, api_auth } from '../../../../common/globals/constants';

import CircularProgress from '@material-ui/core/CircularProgress';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import TextField from '@material-ui/core/TextField/index';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import NativeSelect from '@material-ui/core/NativeSelect';
import InputLabel from '@material-ui/core/InputLabel';
import Grid from '@material-ui/core/Grid';

// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletContent from 'components/PortletContent';
import PortletFooter from 'components/PortletFooter';

import IconButton from '@material-ui/core/IconButton';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import moment from 'moment'
import 'moment/locale/es'  
import { Button } from '@material-ui/core';
// Component styles
import styles from './styles';
moment.locale('es')

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};
const sendValues = (value, nombre, destinatario, telefono, tipo, notificacion_destinatario_id) => {
    let token = sessionStorage.getItem('key')
    let client_id = sessionStorage.getItem('client_id')
    let method = 'POST'
    if (value == 2){
        method = 'PATCH'
    }
    if (value == 3){
        method = 'DELETE'
    }
    return new Promise(resolve => {
        setTimeout(() => {
            fetch(api_host+`/reporte/general/destinatarios/?token=${token}&timestamp=${new Date().getTime()}`, {
                method: method, // or 'PUT'
                body: JSON.stringify({token: token, nombre: nombre, destinatario: destinatario, telefono: telefono, notificacion_tipo_id: tipo, notificacion_destinatario_id: notificacion_destinatario_id, cliente_id: client_id}), // data can be `string` or {object}!
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(res => res.json())
                .catch(error => console.error('Error:', error))
                .then(response => {
                    if (response.status == 3) {
                        resolve(false);
                    } else {
                        resolve(true);
                    }
                }
                );
        }, 100);
    });
};

class Addressee extends Component {

    constructor(props) {
        super(props);

        this.state = {
            currentObjectiveId: this.props.match.params.objetivo_id,
            prevObjectiveId: this.props.match.params.objetivo_id,
            loadObjectiveData: false,
            externalData: null,
            dataError: false,
            isLoading: true,
            sla: null,
            time: 'h',
            step: null,
            hoverData: null,
            lastEvent: [],
            //statePeriod: this.props.params.statePeriod,
            isStatePeriod: false,
            rows: null,
            noMonCum: null,
            downCum: null,
            //date: this.props.params.date,
            dateMoment: ((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a")),
            addEl: null,
            editEl: null,
            deleteEl: null,
            values: {
                destiny: '',
                confirm: '',
                name: '',
                phone: '',
                type: 2,
                destinyEdit: '',
                nameEdit: '',
                phoneEdit: '',
                typeEdit: '',
                addresseeId: 0

            },
            open: false,
            isValid: false,
            validEmail: false,
            validName: false,
            //isRefresh: this.props.params.isRefresh,
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        return null;
    }


    componentDidMount() {
        this.getDataFromAPI();
    }

    componentDidUpdate(prevProps, prevState) {

    }
    componentWillUnmount() {

    }

    getDataFromAPI = (objectiveId) => {
        let token = sessionStorage.getItem('key')
        fetch(api_host+`/reporte/general/destinatarios/?token=${token}&order=1&start=${new Date().getTime()}`)
                .then( response => response.json())
                .then( myJson =>  {
                    try {
                        this.processData(myJson)
                    } catch (error) {
                    this.setState({
                        dataError: true,
                        data: null,
                        isLoading: false
                    });
                }
            });
    }

    // Helper para procesar la data de la petición a la API

    processData = (data) => {

            let notificationsType = data[1]
            let addressee = data[0]
            let arrayRows = []
            
            Object.keys(addressee).map((key0)=> {
                let rows = {}
                rows['notificacionDestinatarioId'] = addressee[key0].notificacion_destinatario_id
                rows['nombre'] = addressee[key0].nombre  
                rows['destinatario'] = addressee[key0].destinatario  
                rows['telefono'] = addressee[key0].telefono  
                rows['editar'] = true 
                rows['eliminar'] = addressee[key0].alarma_asociada  
                rows['tipoId'] = addressee[key0].notificacion_tipo_id
                Object.keys(notificationsType).map((key)=>{
                    if (notificationsType[key].notificacion_tipo_id == addressee[key0].notificacion_tipo_id){
                        rows['tipo'] = notificationsType[key].nombre 
                    }
                })
                arrayRows.push(rows)
            })

            this.setState({
                rows : arrayRows,
                //noMonCum : noMonCumDate,
                //downCum : downCumDate,
                isLoading: false,
                //time: period,
                //step: step,
                dataError: false,
            }); 
       
    }
    handleShowAdd = event => {
        this.setState({
            addEl: event.currentTarget,
            values:{
                type: 2,
            }
        });
    };

    handleCloseAdd = () => {
        this.setState({
            addEl: null,
            validEmail: false,
            validName: false,
        });
    };

    handleShowEdit = (event, value) => {
        this.setState({
            editEl: event.currentTarget,
            values:{
                destinyEdit: value.destinatario,
                nameEdit: value.nombre,
                phoneEdit: value.telefono,
                typeEdit: value.tipoId,
                addresseeId: value.notificacionDestinatarioId
            }
        });
    };

    handleCloseEdit = () => {
        this.setState({
            editEl: null,
            validEmail: false,
            validName: false,
        });
    };

    handleShowDelete = (event, value) => {
        this.setState({
            deleteEl: event.currentTarget,
            values:{
                name: value.nombre,
                addresseeId: value.notificacionDestinatarioId
            }
        });
    };
    handleCloseDelete = () => {
        this.setState({
            deleteEl: null
        });
    };

    handleFieldChange = (field, value) => {
        const newState = { ...this.state };
        newState.values[field] = value;     
        this.setState(newState);
    };

    handleDeleted = async(value) => {
        const {addEl, editEl, values} = this.state;
        var valueMethod = 3
        var nombre = ""
        var destinatario = ""
        var telefono = ""
        var tipo = ""
        var notificacion_destinatario_id = values.addresseeId
        try {
            this.setState({ isLoading: true });
            var ok = await sendValues(valueMethod, nombre, destinatario, telefono, tipo, notificacion_destinatario_id);
            if (ok){
                this.setState({
                    isLoading: true,
                    isValid: true,                   
                    open: true,
                    deleteEl: null

                });
                this.getDataFromAPI();
            } else {
                this.setState({
                    isLoading: false,
                    isValid: false,                   
                    open: true
                });
                
            }

        } catch (error) {
            this.setState({
                isLoading: false,
                //serviceError: error,
                isValid: false,
                open: true
            });
        }
    }

    handleSaved = async (value) => {
        const {addEl, editEl, values} = this.state;
        const showAddEl = Boolean(addEl);   
        const showEditEl = Boolean(editEl); 
      
        var value = 0
        var nombre = ""
        var destinatario = ""
        var telefono = ""
        var tipo = ""
        var notificacion_destinatario_id = 0 
        if (showAddEl){
            value = 1
            nombre = values.name
            destinatario = values.destiny
            telefono = values.phone
            tipo = values.type
        } else if (showEditEl){
            value = 2
            tipo = values.typeEdit
            nombre = values.nameEdit
            destinatario = values.destinyEdit
            telefono = values.phoneEdit
            notificacion_destinatario_id = values.addresseeId
        } 
        try {
            this.setState({ isLoading: true });
            var ok = await sendValues(value, nombre, destinatario, telefono, tipo, notificacion_destinatario_id);
            if (ok){
                this.setState({
                    isLoading: true,
                    isValid: true,                   
                    open: true,
                    editEl: null,
                    addEl: null,
                    validEmail: false,
                    validName: false,

                });
                this.getDataFromAPI();
            } else {
                this.setState({
                    isLoading: false,
                    isValid: false,                   
                    open: true,
                });
                
            }

        } catch (error) {
            this.setState({
                isLoading: false,
                //serviceError: error,
                isValid: false,
                open: true
            });
        }
    }

    handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          	return;
        }
        this.setState({
            open: false 
        })
    };
    
    validateEmail = (email) => {
        var re = /\S+@\S+\.\S+/;      
        if (re.test(email)) {
            this.setState({
                validEmail: false,
            });
        } else {
            this.setState({
                validEmail: true,
            });
        }
    }
    validateName = (name) => {
        if (!name) {
            this.setState({
                validName: true,
            });
        } else {
            this.setState({
                validName: false,
            });
        }
    }


    render() {
        const { classes, className, t, ...rest } = this.props;
        const { dataError, isLoading, rows, noMonCum, downCum, addEl, editEl, deleteEl, open, isValid, validEmail, validName} = this.state;
        const {destinyEdit, nameEdit, phoneEdit, typeEdit, name } = this.state.values
        const style = isLoading ? { display: 'none' } : {};
        const styleHidden = isLoading ? {} : { display: 'none' };    
        const showAddEl = Boolean(addEl);   
        const showEditEl = Boolean(editEl); 
        const showDeleteEl = Boolean(deleteEl); 
        const rootClassName = classNames(classes.root, className);
  
            if (!dataError) {
            return (<FormattedChart t={t} classes={classes} rows={rows} noMonCum={noMonCum} downCum={downCum} isLoading={isLoading} style={style} styleHidden={styleHidden}
                                    handleCloseAdd={this.handleCloseAdd} handleShowAdd={this.handleShowAdd} showAddEl={showAddEl}
                                    handleFieldChange={this.handleFieldChange}
                                    handleCloseEdit={this.handleCloseEdit} handleShowEdit={this.handleShowEdit} showEditEl={showEditEl} 
                                    destinyEdit={destinyEdit} nameEdit={nameEdit} phoneEdit={phoneEdit} typeEdit={typeEdit}
                                    handleDeleted={this.handleDeleted} handleSaved={this.handleSaved}
                                    open={open} isValid={isValid} handleClose={this.handleClose}
                                    handleCloseDelete={this.handleCloseDelete} handleShowDelete={this.handleShowDelete} showDeleteEl={showDeleteEl}
                                    name={name} validEmail={validEmail} validateEmail={this.validateEmail} 
                                    validName={validName} validateName={this.validateName}/>) 
        }
        else if (dataError) {
            return (<p>No hay datos..</p>)
        }
        else return (<p> Error!</p >)

    }
}

function FormattedChart(props) {
    const { t } = props;
    return (
        <div>
            { props.rows == null  ? 
                <Grid style={{fontFamily: '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif', height: '85px', fontSize: '14px', color: '#666666', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Grid item style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '24px', padding: "0.5rem" }} >
                        <CircularProgress variant="indeterminate" size={24} thickness={4} />
                    </Grid>
                    <Grid item style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '24px', padding: "0.5rem" }} >
                            {t('settings.addressee.loading')}
                    </Grid>
                </Grid>
            :
                <div style={{ maxWidth: "100%" }}>
                    {/*<Button style={{backgroundColor: 'white'}} variant="outlined" color="primary" size="small">
                        <Typography variant="button"> Agregar contacto </Typography>
                    </Button>*/}
                                        <MaterialTable
                        
                                                icons={tableIcons}
                                                columns={[
                                                        { width: 100, title: t('settings.addressee.columns.name'), field: "nombre"/*, defaultGroupOrder: 0*/,headerStyle: {
                                                                backgroundColor: '#6d6d6d',
                                                                color: '#FFF'
                                                            } },
                                                        { width: 100, title: t('settings.addressee.columns.destiny'), field: "destinatario" ,headerStyle: {
                                                                backgroundColor: '#6d6d6d',
                                                                color: '#FFF'
                                                            } },
                                                        { width: 100, title: t('settings.addressee.columns.type'), field: "tipo"/*, type: "numeric"*/ ,headerStyle: {
                                                                backgroundColor: '#6d6d6d',
                                                                color: '#FFF'
                                                            } },
                                                        { width: 100, title: t('settings.addressee.columns.phone'), field: "telefono"/*, type: "numeric"*/,headerStyle: {
                                                                backgroundColor: '#6d6d6d',
                                                                color: '#FFF'
                                                            } },
                                                        { width: 100, title: t('settings.addressee.columns.tipoId'), field: "tipoId"/*, type: "numeric"*/,headerStyle: {
                                                                backgroundColor: '#6d6d6d',
                                                                color: '#FFF'
                                                            }, hidden: true },
                                                        { width: 100, title: t('settings.addressee.columns.edit'), field: "editar"/*, type: "numeric"*/,headerStyle: {
                                                                backgroundColor: '#6d6d6d',
                                                                color: '#FFF'
                                                            }, hidden: true },
                                                        { width: 100, title: t('settings.addressee.columns.delete'), field: "eliminar"/*, type: "numeric"*/,headerStyle: {
                                                                backgroundColor: '#6d6d6d',
                                                                color: '#FFF'
                                                            }, hidden: true},
                                                            { width: 100, title: t('settings.addressee.columns.notificacionDestinatarioId'), field: "notificacionDestinatarioId"/*, type: "numeric"*/,headerStyle: {
                                                                    backgroundColor: '#6d6d6d',
                                                                    color: '#FFF'
                                                                }, hidden: true}
                                                ]}
                        /*data={[
                            { monitor: "Claro (cl)", paso: "Home", minimo: 0.320, maximo: 22.700, promedio: 2.590, uptime: 100.000, downtime: 0.000, nomon: 0.000, total: 213  },
                            { monitor: "Claro (cl)", paso: "Login", minimo: 0.320, maximo: 22.700, promedio: 2.590, uptime: 100.000, downtime: 0.000, nomon: 0.000, total: 213  },
                            { monitor: "Claro (cl)", paso: "Liquidaciones", minimo: 0.320, maximo: 22.700, promedio: 2.590, uptime: 100.000, downtime: 0.000, nomon: 0.000, total: 213  },
                            { monitor: "Entel (cl)", paso: "Home", minimo: 0.280, maximo: 4.580, promedio: 2.470, uptime: 99.530, downtime: 0.470, nomon: 0.000, total: 213  }
                        ]}*/
                        data={props.rows} 
                        title={t('settings.addressee.hint')}
                        localization={{
                            grouping: {
                                groupedBy: t('settings.addressee.localization.groupedBy'),
                                placeholder: t('settings.addressee.localization.placeholder'),
                            },
                            body: {
                                emptyDataSourceMessage: t('settings.addressee.localization.empty')
                            },
                            toolbar: {
                                searchTooltip: t('settings.addressee.localization.searchTooltip'),
                                searchPlaceholder: t('settings.addressee.localization.searchPlaceholder')
                            },
                            pagination: {
                                labelRowsSelect: t('settings.addressee.localization.pagination.labelRowsSelect'),
                                labelDisplayedRows: t('settings.addressee.localization.pagination.labelDisplayedRows'),
                                firstTooltip: t('settings.addressee.localization.pagination.firstTooltip'),
                                previousTooltip: t('settings.addressee.localization.pagination.previousTooltip'),
                                nextTooltip: t('settings.addressee.localization.pagination.nextTooltip'),
                                lastTooltip: t('settings.addressee.localization.pagination.lastTooltip')
                            },
                            header: {
                                actions: '',
                                headerStyle: {
                                    backgroundColor: '#0c0033',
                                    color: '#FFF'
                                }
                            },
                        }}
                        options={{
                            grouping: true,
                            actionsColumnIndex: -1,
                            headerStyle: {
                                backgroundColor: '#6d6d6d',
                                color: '#FFF'
                            }
                        }}
                        actions={[
                            {
                                icon: AddCircleOutlineIcon,
                                tooltip: t('settings.addressee.actions.add'),
                                isFreeAction: true,
                                //onClick: (event) => alert("You want to add a new row")
                                onClick: props.handleShowAdd
                            },
                            {
                                icon: Edit,
                                tooltip: t('settings.addressee.actions.edit'),
                                //props.handleFieldChange('name', event.target.value)
                                //onClick: (event, rowData) => alert("You saved " + rowData.nombre)
                                onClick: (event, rowData) => props.handleShowEdit(event, rowData)
                            },
                            
                            rowData => ({
                                icon: DeleteOutline,
                                tooltip: t('settings.addressee.actions.delete'),
                                onClick: (event, rowData) => props.handleShowDelete(event, rowData),
                                disabled: rowData.eliminar,
                                hidden: rowData.eliminar
                            })
                        ]}
                    />

                    <Modal
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        open={props.showAddEl}
                        onClose={props.handleCloseAdd}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                        disableAutoFocus={true}
                        disableEnforceFocus={true}
                        closeAfterTransition
                        BackdropComponent={Backdrop}
                        BackdropProps={{
                            timeout: 500,
                        }}
                    >                                    
                        <Fade in={props.showAddEl}>
                            <PerfectScrollbar>
                                <div className={props.classes.modal}>                             
                                    <Portlet
                                        
                                        className={props.rootClassName}
                                    >
                                        <PortletHeader>
                                            <PortletLabel
                                                //subtitle="Actualizar Contraseña"
                                                title={t('settings.addressee.contactInfoTitle')}
                                            />
                                        </PortletHeader>
                                        <PortletContent>
                                            <form autoComplete="off" noValidate className={props.classes.form}>
                                                <TextField
                                                    className={props.classes.textField}
                                                    label={t('settings.addressee.form.name')}
                                                    name="name"
                                                    onChange={event =>
                                                        props.handleFieldChange('name', event.target.value)
                                                    }
                                                    type="text"
                                                    required
                                                    onBlur={event =>
                                                        props.validateName(event.target.value)
                                                    }
                                                    error={props.validName}
                                                    helperText={props.validName ? t('settings.addressee.form.helper.invalidName') : ''}
                                                    //helperText="Incorrect entry."
                                                    variant="outlined"
                                                />
                                                <TextField
                                                    onBlur={event =>
                                                        props.validateEmail(event.target.value)
                                                    }
                                                    error={props.validEmail}
                                                    helperText={props.validEmail ? t('settings.addressee.form.helper.invalidEmail') : ''}
                                                    className={props.classes.textField}
                                                    label={t('settings.addressee.form.destiny')}
                                                    name="destiny"
                                                    required
                                                    onChange={event =>
                                                        props.handleFieldChange('destiny', event.target.value)
                                                    }
                                                    type="email"
                                                    //value={values.newPass}
                                                    variant="outlined"
                                                />
                                                <FormControl className={props.classes.formControl}>   
                                                    <InputLabel htmlFor="age-native-helper">{t('settings.addressee.form.typeLabel')}</InputLabel>
                                                    <NativeSelect
                                                        className={props.classes.textField}
                                                        //value="orientación semaforo"
                                                        name="type"
                                                        onChange={event =>
                                                            props.handleFieldChange('type', event.target.value)
                                                        }
                                                        //value={values.orientation.value}
                                                        variant="outlined"
                                                    >
                                                        <option value={2}>{t('settings.addressee.typeOptions.email')}</option>
                                                        <option value={3}>{t('settings.addressee.typeOptions.emailSummary')}</option>
                                                        <option value={1}>{t('settings.addressee.typeOptions.emailToMobile')}</option>
                                                        <option value={7}>{t('settings.addressee.typeOptions.integrationAlert')}</option>
                                                    </NativeSelect>
                                                </FormControl>
                                                <TextField
                                                    className={props.classes.textField}
                                                    label={t('settings.addressee.form.phone')}
                                                    name="phone"
                                                    inputProps={{ pattern:'\x2b[0-9]+' }}
                                                    onChange={event =>
                                                        props.handleFieldChange('phone', event.target.value)
                                                    }
                                                    type="text"
                                                    //value={values.confirmPass}
                                                    variant="outlined"
                                                />
                                                
                                            </form>
                                            
                                        </PortletContent>
                                        <PortletFooter className={props.classes.portletFooter} align="center">
                                            <Button
                                                color="primary"
                                                variant="contained"
                                                onClick={props.handleSaved}
                                            >
                                                {t('settings.addressee.buttons.save')}
                                            </Button><>&nbsp;</> <>&nbsp;</> <>&nbsp;</>
                                            <Button
                                                color="primary"
                                                variant="outlined"
                                                onClick={props.handleCloseAdd}
                                            >
                                                {t('settings.addressee.buttons.cancel')}
                                            </Button>
                                        </PortletFooter>
                                    </Portlet>                          
                                </div>
                            </PerfectScrollbar>
                        </Fade>
                    </Modal>
                    <Modal
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        open={props.showEditEl}
                        onClose={props.handleCloseEdit}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                        disableAutoFocus={true}
                        disableEnforceFocus={true}
                        closeAfterTransition
                        BackdropComponent={Backdrop}
                        BackdropProps={{
                            timeout: 500,
                        }}
                    >                                    
                        <Fade in={props.showEditEl}>
                            <PerfectScrollbar>
                                <div className={props.classes.modal}>                             
                                    <Portlet
                                        
                                        className={props.rootClassName}
                                    >
                                        <PortletHeader>
                                            <PortletLabel
                                                //subtitle="Actualizar Contraseña"
                                                title={t('settings.addressee.contactInfoTitle')}
                                            />
                                            <IconButton onClick={props.handleCloseEdit} ><CloseIcon/></IconButton>
                                        </PortletHeader>
                                        <PortletContent>
                                            <form className={props.classes.form}>
                                                <TextField
                                                    required
                                                        onBlur={event =>
                                                            props.validateName(event.target.value)
                                                        }
                                                        error={props.validName}
                                                        helperText={props.validName ? t('settings.addressee.form.helper.invalidName') : ''}
                                                        className={props.classes.textField}
                                                        label={t('settings.addressee.form.name')}
                                                    name="nameEdit"
                                                    onChange={event =>
                                                        props.handleFieldChange('nameEdit', event.target.value)
                                                    }
                                                    type="text"
                                                    value={props.nameEdit}
                                                    variant="outlined"
                                                />
                                                <TextField
                                                    onBlur={event =>
                                                            props.validateEmail(event.target.value)
                                                        }
                                                        error={props.validEmail}
                                                        helperText={props.validEmail ? t('settings.addressee.form.helper.invalidEmail') : ''}
                                                        required
                                                        className={props.classes.textField}
                                                        label={t('settings.addressee.form.destiny')}
                                                    name="destinyEdit"
                                                    onChange={event =>
                                                        props.handleFieldChange('destinyEdit', event.target.value)
                                                    }
                                                    type="email"
                                                    value={props.destinyEdit}
                                                    variant="outlined"
                                                />
                                                <FormControl className={props.classes.formControl}>   
                                                    <InputLabel htmlFor="age-native-helper">{t('settings.addressee.form.typeLabel')}</InputLabel>
                                                    {props.typeEdit == 4?
                                                        <NativeSelect
                                                            className={props.classes.textField}
                                                            //value="orientación semaforo"
                                                            name="typeEdit"
                                                            onChange={event =>
                                                                props.handleFieldChange('typeEdit', event.target.value)
                                                            }
                                                            value={props.typeEdit}
                                                            variant="outlined"
                                                        > 
                                                            <option value={4}>{t('settings.addressee.typeOptions.sms')}</option>
                                                            <option value={2}>{t('settings.addressee.typeOptions.email')}</option>
                                                            <option value={3}>{t('settings.addressee.typeOptions.emailSummary')}</option>
                                                            <option value={1}>{t('settings.addressee.typeOptions.emailToMobile')}</option>
                                                            <option value={7}>{t('settings.addressee.typeOptions.integrationAlert')}</option>
                                                        </NativeSelect>
                                                    :props.typeEdit == 5?
                                                        <NativeSelect
                                                            className={props.classes.textField}
                                                            //value="orientación semaforo"
                                                            name="typeEdit"
                                                            onChange={event =>
                                                                props.handleFieldChange('typeEdit', event.target.value)
                                                            }
                                                            value={props.typeEdit}
                                                            variant="outlined"
                                                        > 
                                                            <option value={5}>{t('settings.addressee.typeOptions.telegram')}</option>
                                                            <option value={2}>{t('settings.addressee.typeOptions.email')}</option>
                                                            <option value={3}>{t('settings.addressee.typeOptions.emailSummary')}</option>
                                                            <option value={1}>{t('settings.addressee.typeOptions.emailToMobile')}</option>
                                                            <option value={7}>{t('settings.addressee.typeOptions.integrationAlert')}</option>
                                                        </NativeSelect>
                                                    :
                                                        <NativeSelect
                                                            className={props.classes.textField}
                                                            //value="orientación semaforo"
                                                            name="typeEdit"
                                                            onChange={event =>
                                                                props.handleFieldChange('typeEdit', event.target.value)
                                                            }
                                                            value={props.typeEdit}
                                                            variant="outlined"
                                                        > 
                                                            <option value={2}>{t('settings.addressee.typeOptions.email')}</option>
                                                            <option value={3}>{t('settings.addressee.typeOptions.emailSummary')}</option>
                                                            <option value={1}>{t('settings.addressee.typeOptions.emailToMobile')}</option>
                                                            <option value={7}>{t('settings.addressee.typeOptions.integrationAlert')}</option>
                                                        </NativeSelect>}
                                                </FormControl>
                                                <TextField
                                                    className={props.classes.textField}
                                                    label={t('settings.addressee.form.phone')}
                                                    name="phoneEdit"
                                                    inputProps={{ pattern:'\x2b[0-9]+' }}
                                                    onChange={event =>
                                                        props.handleFieldChange('phoneEdit', event.target.value)
                                                    }
                                                    type="text"
                                                    value={props.phoneEdit}
                                                    variant="outlined"
                                                />
                                                
                                            </form>
                                            
                                        </PortletContent>
                                        <PortletFooter className={props.classes.portletFooter} align="center">
                                            <Button
                                                color="primary"
                                                variant="contained"
                                                onClick={props.handleSaved}
                                            >
                                                {t('settings.addressee.buttons.save')}
                                            </Button> <>&nbsp;</> <>&nbsp;</> <>&nbsp;</>
                                            <Button
                                                color="primary"
                                                variant="outlined"
                                                onClick={props.handleCloseEdit}
                                            >
                                                {t('settings.addressee.buttons.cancel')}
                                            </Button>
                                        </PortletFooter>
                                    </Portlet>                          
                                </div>
                            </PerfectScrollbar>
                        </Fade>
                    </Modal>
                    <Modal
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        open={props.showDeleteEl}
                        onClose={props.handleCloseDelete}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                        disableAutoFocus={true}
                        disableEnforceFocus={true}
                        closeAfterTransition
                        BackdropComponent={Backdrop}
                        BackdropProps={{
                            timeout: 500,
                        }}
                    >                                    
                        <Fade in={props.showDeleteEl}>
                            <PerfectScrollbar>
                                <div className={props.classes.modalDeleted}>                             
                                    <Portlet
                                        className={props.rootClassName}
                                    >
                                        
                                        <PortletLabel
                                            className={props.classes.portletFooter}
                                            //subtitle="Actualizar Contraseña"
                                            title={t('settings.addressee.deleteConfirm', { name: props.name })}
                                        />
                                        
                                        
                                        <PortletFooter className={props.classes.portletFooter}>
                                            <Button
                                                color="primary"
                                                variant="contained"
                                                onClick={props.handleDeleted}
                                            >
                                                {t('settings.addressee.buttons.accept')}
                                            </Button>
                                            <Button
                                                color="primary"
                                                variant="outlined"
                                                onClick={props.handleCloseDelete}
                                            >
                                                {t('settings.addressee.buttons.cancel')}
                                            </Button>
                                        </PortletFooter>
                                    </Portlet>                          
                                </div>
                            </PerfectScrollbar>
                        </Fade>
                    </Modal>
                    <Snackbar
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        open={props.open}
                        autoHideDuration={6000}
                        onClose={props.handleClose}
                        >
                            <SnackbarContent
                                className={props.isValid ? props.classes.snackContentOk
                                            : props.classes.snackContent}
                                aria-describedby="client-snackbar"
                                message={
                                    
                                    props.isValid ?
                                            <span id="client-snackbar" className={props.classes.message}>
                                                <CheckCircleIcon className={(props.classes.icon, props.classes.iconVariant)}/>
                                                {t('settings.addressee.snackbar.success')}
                                            </span>
                                        :	<span id="client-snackbar" className={props.classes.message}>
                                                <ErrorIcon className={(props.classes.icon, props.classes.iconVariant)}/>
                                                {t('settings.addressee.snackbar.error')}
                                                ({t('settings.addressee.snackbar.errorHelp')})
                                            </span>
                                    
                                }
                                action={[
                                    <IconButton key="close" aria-label="close" color="inherit" onClick={props.handleClose}>
                                        <CloseIcon className={props.classes.icon}/>
                                    </IconButton>
                                ]}
                            />
                    </Snackbar>
                </div>
                
            }
            </div>
        )

}

export default compose(withRouter, withStyles(styles), withTranslation())(Addressee);
